// @owner ClientPlatform

import axios from 'axios';

export const requester = axios.create({
  withCredentials: true,
  xsrfCookieName: 'front.csrf',
  xsrfHeaderName: 'X-Front-Xsrf',
});
